import cookie from 'js-cookie'

export function get (key) {
  return cookie.get(key)
}

export function set (key, value) {
  return cookie.set(key, value)
}

export function remove (key) {
  cookie.remove(key)
}
